export default "__VITE_ASSET__CcyH8BEo__"